export interface LicenceStatusDto {
    organizationId: string;
    totalLicenses: number;
    activeCompanies: number;
    available: number;
    endDate: Date;
}
